import React, { useState } from "react";
import { Box, Tabs, Tab, Paper } from "@mui/material";
import Reports from "./Reports";
import UserActivityReport from "./UserActivityReport";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`reports-tabpanel-${index}`}
      aria-labelledby={`reports-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const ReportsDashboard = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="reports dashboard tabs"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "1rem",
            },
            "& .Mui-selected": {
              color: "#4D8FAC",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#4D8FAC",
            },
          }}
        >
          <Tab label="Application Reports" />
          <Tab label="User Activity Report" />
        </Tabs>
      </Paper>

      <TabPanel value={tabValue} index={0}>
        <Reports />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <UserActivityReport />
      </TabPanel>
    </Box>
  );
};

export default ReportsDashboard;
